var map = {
	"./controllers/previews/left.svg": "ee42",
	"./controllers/previews/none.svg": "6e42",
	"./controllers/previews/right.svg": "7d84",
	"./flags/en.svg": "7534",
	"./flags/es.svg": "b45f",
	"./flags/pt-br.svg": "3523",
	"./logo-primary.svg": "21a3",
	"./logo-white.svg": "e1d6",
	"./logo.svg": "1ae4",
	"./ow-logo.svg": "3314",
	"./positions/previews/bottom.svg": "312a",
	"./positions/previews/center.svg": "78e9",
	"./positions/previews/left.svg": "2ec0",
	"./positions/previews/right.svg": "ce75",
	"./positions/previews/top.svg": "49cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";